<div class="td-wb-modal-notification">
  <h1 class="td-wb-modal-notification__header"
      translate="tdWb.modalNotification.fhsaAccount.TITLE"></h1>
  <div class="td-wb-modal-notification__row">
    <div class="td-wb-modal-notification__left">
      <p class="td-wb-modal-notification__copy--bold"
         translate="tdWb.modalNotification.fhsaAccount.DESCRIPTION">
      </p>
      <ul class="td-wb-ul td-wb-ul--basic td-wb-modal-notificiation__list">
        <li translate="tdWb.modalNotification.fhsaAccount.DETAILS_I"></li>
        <li translate="tdWb.modalNotification.fhsaAccount.DETAILS_II"></li>
        <li translate="tdWb.modalNotification.fhsaAccount.DETAILS_III"></li>
      </ul>
      <a class="td-wb-modal-notification__link"
         href="#/page/preferences/sso"
         translate="tdWb.modalNotification.fhsaAccount.OPEN_ACCOUNT"></a>
    </div>
    <div class="td-wb-modal-notification--image-container">
      <img tdWbModalNotificationImage
           src="fhsa-account.svg"
           width="200px"
           [attr.alt]="'tdWb.modalNotification.fhsaAccount.TITLE' | translate"
           class="td-wb-modal-notification--image-small">
    </div>
  </div>
</div>
